import React from 'react'

// scss
import './whatsapp.scss'

const Whatsapp = () => <i class="fa fa-whatsapp " aria-hidden="true" 
onClick={() => window.open(`https://api.whatsapp.com/send?phone='+92-3**-******'&text=${encodeURIComponent('Hi Ava! Please can you guide me about')}`, '_blank')}
/>

export default Whatsapp